import { IconSize, StyledIcon, StyledSvg } from './Icon.style';

export interface IconProps {
  name: string;
  size?: IconSize;
  title?: string;
  angle?: number;
  color?: string;
  highlightColor?: string;
  onClick?: (any: any) => void;
}

export function Icon({
  name,
  size = 'Small',
  title,
  angle,
  color,
  highlightColor,
  onClick,
}: IconProps) {
  return (
    <StyledIcon size={size} onClick={onClick} aria-label={title} role={title ? 'img' : undefined}>
      <StyledSvg
        className={`icon-${name}`}
        angle={angle}
        size={size}
        color={color}
        highlightColor={highlightColor}
        style={angle ? { transform: `rotate(${angle}deg)` } : {}}
        aria-hidden="true"
      >
        <use xlinkHref={`#${name}`} />
      </StyledSvg>
    </StyledIcon>
  );
}
